const TAX_CATEGORIES = {
	Alberta: ["GST 5%", "Exempt"],
	"British Columbia": ["GST & PST 12%", "M&E 2.5%", "Exempt"],
	Manitoba: ["GST 5%", "PST 7%", "M&E 2.5%", "Exempt"],
	"New Brunswick": ["HST 15%", "M&E 7.5%", "Exempt"],
	"Newfoundland and Labrador": ["HST 15%", "M&E 7.5%", "Exempt"],
	"Northwest Territories": ["GST 5%", "Exempt"],
	"Nova Scotia": ["HST 15%", "M&E 7.5%", "Exempt"],
	Nunavut: ["GST 5%", "Exempt"],
	Ontario: ["HST 13%", "M&E 6.5%", "Exempt"],
	"Prince Edward Island": ["HST 15%", "M&E 7.5%", "Exempt"],
	Quebec: ["GST 5%", "QST 9.975%", "M&E 2.5%", "M&E 4.9875%", "Exempt"],
	Saskatchewan: ["GST 5%", "PST 6%", "M&E 2.5%", "Exempt"],
	Yukon: ["GST 5%", "Exempt"]
};

export default TAX_CATEGORIES;
